// extracted by mini-css-extract-plugin
export default {"heading":"EvidenceContainerStyles_heading__LW7HD","btn-style":"EvidenceContainerStyles_btn-style__rTsQs","btn-style-disabled":"EvidenceContainerStyles_btn-style-disabled__kectr"};